import { InjectionToken } from "@angular/core";

export const API_URL = new InjectionToken<string>("Api URL");
export const APP_CONFIG = new InjectionToken("App configuration");
export const ENVIRONMENT = new InjectionToken<any>("ENVIRONMENT")